import { render, staticRenderFns } from "./NotificacionesNewOrEdit.vue?vue&type=template&id=017696aa&"
import script from "./NotificacionesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./NotificacionesNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports